/* import __COLOCATED_TEMPLATE__ from './plus-tier-banner.hbs.js'; */
import Component from '@ember/component';

/**
## Upsell::PlusTierBanner

Shows a large banner with black background to upsell Best (Pro) features within a
Good/Better/Best Tiered vertical (i.e. Restaurants and Retail).

### Params
@param {String} verticalName - The name of the vertical that is being upsold, e.g. Square for Restaurants
@param {String} title - The title of the feature that is being upsold
@param {String} details - Details that describe the titled feature and prompt the upsell
@param {String} buttonLabel - The CTA text displayed on the button, e.g. Upgrade to Pro
@param {String} [buttonClass] - A class that can apply custom styling to the button (beyond button--primary)
@param {String} buttonAction - The action that is triggered when the button is clicked

### Example usage
hbs```
<Upsell::PlusTierBanner
  @verticalName={{t "common.vertical.restaurant"}}
  @title="Reopen Closed Checks"
  @details="Upgrade to Restaurants POS Plus to reopen closed checks."
  @buttonLabel="Upgrade to Pro"
  @buttonClass="dummy__button--rst-orange"
  @buttonAction={{action "popup"}} />
```
*/

export default class PlusTierBanner extends Component {}